import React from 'react';

function AccountsEdit({ color = '#335B70', ...props }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.583 17.541l-4 4h-.373a.43.43 0 01-.435-.425v-3.604a.836.836 0 00-.17-.504l1.586-1.586h.982v-.983l1.545-1.544.865.865v3.781zm0-8.215l-.803.803-.062-.063-2.908 2.908h-1.047v1.047l-2.64 2.64H9.617c-.48 0-.87.382-.87.851v3.604a.43.43 0 01-.435.426H5.657c-.96 0-1.74-.764-1.74-1.703V3.66c0-.939.78-1.703 1.74-1.703h12.186c.96 0 1.74.764 1.74 1.703v5.665zm-8.215 12.216h2.19v-3.487l-2.19 2.189v1.298zm-.454-3.672l-.972.972v-.972h.972zm3.849-13.464h2.41v2.448h-2.41V4.406zm0 4.284h2.41v2.448h-2.41V8.69zm-1.808 4.284h-2.41v2.448h2.41v-2.448zm-2.41-4.284h2.41v2.448h-2.41V8.69zm-1.808 4.284h-2.41v2.448h2.41v-2.448zm4.218-8.568h-2.41v2.448h2.41V4.406zm-6.628 0h2.41v2.448h-2.41V4.406zm2.41 4.284h-2.41v2.448h2.41V8.69z"
                fill={color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.474 15.65l-2.756-2.755-7.35 7.349V23h2.756l7.35-7.35zm2.32-2.446a.699.699 0 000-.989l-1.64-1.641a.699.699 0 00-.99 0l-1.375 1.374 2.63 2.63 1.376-1.374z"
                fill={color}
            />
        </svg>
    );
}

export default AccountsEdit;
